import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UnsubscribeFromLcdCreditAnalysisResultModal} from './unsubscribe-from-lcd-credit-analysis.result.modal';
import {
    clearResult,
    unsubscribeFromLcdCreditAnalysisShownSelector,
    unsubscribeFromLcdCreditAnalysisTaskSelector,
    unsubscribeFromLcdCreditAnalysisUuidSelector,
} from './unsubscribe-from-lcd-credit-analysis.slice';


export const UnsubscribeFromLcdCreditAnalysisResult = () => (
    <BulkActionResult
        actionIdSelector={unsubscribeFromLcdCreditAnalysisUuidSelector}
        actionTaskSelector={unsubscribeFromLcdCreditAnalysisTaskSelector}
        actionShownSelector={unsubscribeFromLcdCreditAnalysisShownSelector}
        clearResult={clearResult}>
        {({id, onClose}) => <UnsubscribeFromLcdCreditAnalysisResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
